import { render, staticRenderFns } from "./FichaTecnicaInfoCards.vue?vue&type=template&id=71099b32&scoped=true"
import script from "./FichaTecnicaInfoCards.vue?vue&type=script&lang=js"
export * from "./FichaTecnicaInfoCards.vue?vue&type=script&lang=js"
import style0 from "./FichaTecnicaInfoCards.vue?vue&type=style&index=0&id=71099b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71099b32",
  null
  
)

export default component.exports